import React from "react";
import LinkedIn from "../../assets/LinkedIn.png";
import Gmail from "../../assets/Gmail.png";
import Twitter from "../../assets/Twitter.png";
import VectorImage from "../../assets/VectorImage.png";
import Baseindex from "./base";
export default function AboutIndex() {
  return (
    <div className=" pl-24 pr-24 content-start flex-col  p-4 justify-center  flex ">
      <div className="font-normal mb-4 self-center text-transparent bg-clip-text bg-gradient-to-br from-[#E975A8] to-[#726CF8] text-4xl">
        ABOUT US
      </div>
      <div className="text-white">
        Lorem ipsum dolor sit amet consectetur. Arcu adipiscing senectus
        adipiscing varius lacus pellentesque auctor. Lacus turpis vestibulum
        consectetur scelerisque est. Egestas a dolor vitae egestas sagittis
        tellus volutpat in.
      </div>
      <div className="text-white mt-3">
        {" "}
        Consequat enim urna sit tincidunt eget duis interdum. Lorem dui velit
        arcu et pharetra eget. Eu ac integer vulputate molestie amet auctor
        nulla tempor ultrices. Auctor nunc non aliquam morbi eros eu. Cras dolor
        facilisis malesuada posuere ut nulla at tellus sit. Et bibendum bibendum
        hac mauris eu feugiat.
      </div>
      <div className="text-white mt-3">
        {" "}
        Ac nam ipsum consectetur pulvinar accumsan felis suspendisse vitae id.
        Nulla faucibus elementum in volutpat id vitae porttitor consectetur.
        Eros eu hac ac arcu. Nulla ligula massa mi vitae lacinia tortor. Lectus
        ac nullam velit convallis risus. Donec sapien netus a arcu. Maecenas eu
        vestibulum auctor mi. Aliquet in sapien faucibus velit turpis. Varius
        nunc blandit eget est aliquam. Imperdiet vel quis nunc ligula.
      </div>
      <div className="font-normal mt-24 self-center text-transparent bg-clip-text bg-gradient-to-br from-[#E975A8] to-[#726CF8] text-4xl">
        TEAMS
      </div>

      <div className="flex flex-row mb-8">
        <div className="w-6/12 min-w-fit h-full m-5">
          <img src={VectorImage} />
        </div>
        <div className="flex flex-col">
          <div className="text-white mt-3 w-1/4 ">MICHEAL OJO</div>
          <div className="text-[#999999] mt-3 w-1/4">CEO</div>
          <div className="text-white mt-3 ">
            Lorem ipsum dolor sit amet consectetur. Sociis quis vel posuere
            senectus penatibus arcu. Libero est nunc maecenas eu diam cursus
            condimentum. Cursus nascetur tortor nunc aliquet. Id neque odio odio
            dolor condimentum tortor imperdiet blandit quis. Tristique at
            gravida facilisis non in mattis in tellus.
          </div>
          <div className="flex-row flex w-1/4 space-x-7 mt-6">
            <img src={LinkedIn} />
            <img src={Gmail} />
            <img src={Twitter} />
          </div>
        </div>
      </div>

      <div className="flex flex-row mb-8 mt-8">
        <div className="flex flex-col">
          <div className="text-white mt-3 w-1/4 ">MICHEAL OJO</div>
          <div className="text-[#999999] mt-3 w-1/4">CEO</div>
          <div className="text-white mt-3 ">
            Lorem ipsum dolor sit amet consectetur. Sociis quis vel posuere
            senectus penatibus arcu. Libero est nunc maecenas eu diam cursus
            condimentum. Cursus nascetur tortor nunc aliquet. Id neque odio odio
            dolor condimentum tortor imperdiet blandit quis. Tristique at
            gravida facilisis non in mattis in tellus.
          </div>
          <div className="flex-row flex w-1/4 space-x-7 mt-6">
            <img src={LinkedIn} />
            <img src={Gmail} />
            <img src={Twitter} />
          </div>
        </div>
        <div className="w-6/12 min-w-fit h-full m-5">
          <img src={VectorImage} />
        </div>
      </div>

      <div className="flex flex-row mb-8 mt-8">
        <div className="w-6/12 min-w-fit h-full m-5">
          <img src={VectorImage} />
        </div>
        <div className="flex flex-col">
          <div className="text-white mt-3 w-1/4 ">MICHEAL OJO</div>
          <div className="text-[#999999] mt-3 w-1/4">CEO</div>
          <div className="text-white mt-3 ">
            Lorem ipsum dolor sit amet consectetur. Sociis quis vel posuere
            senectus penatibus arcu. Libero est nunc maecenas eu diam cursus
            condimentum. Cursus nascetur tortor nunc aliquet. Id neque odio odio
            dolor condimentum tortor imperdiet blandit quis. Tristique at
            gravida facilisis non in mattis in tellus.
          </div>
          <div className="flex-row flex w-1/4 space-x-7 mt-6">
            <img src={LinkedIn} />
            <img src={Gmail} />
            <img src={Twitter} />
          </div>
        </div>
      </div>

      <Baseindex />
    </div>
  );
}
